export interface ManualSubsection {
    label: string;
    slug: string;
}

export interface ManualSubsectionGroup {
    label: string;
    slug: string;
    subsections: ManualSubsection[];
}

export interface ManualPage {
    label: string;
    slug: string;
    subsections?: ManualSubsection[];
    groups?: ManualSubsectionGroup[];
    /**
     * Set when the page itself has its own markdown doc (e.g. `project-list.md`)
     * in addition to its subsections. When true, the sidebar renders the page
     * label as a navigable link (separate from the expand/collapse chevron).
     */
    hasOwnPage?: boolean;
}

export interface ManualSection {
    label: string;
    slug: string;
    icon: string;
    pages: ManualPage[];
    /** If set, the section is only visible/accessible to users with at least one of these roles. */
    allowedRoles?: string[];
}

export interface ManualVersion {
    label: string;
    slug: string;
    sections: ManualSection[];
}

/**
 * Role restrictions per manual section slug, keyed independently of
 * `ManualVersion.sections` so the route guard (which only has the `:section`
 * route param, not the component's data) can enforce the same restriction
 * used to hide/show sections in the sidebar (see `ManualsComponent`).
 */
export const MANUAL_SECTION_ROLES: Record<string, string[]> = {
    'io-test': ['admin', 'superadmin'],
    'technical-documentation': ['admin', 'superadmin'],
};
